import { render } from "./GenerateDeliveries.vue?vue&type=template&id=a167e436"
import script from "./GenerateDeliveries.vue?vue&type=script&lang=js"
export * from "./GenerateDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__